export function setPickerValue(picker) {
    let value = picker.startDate.format(picker.locale.format) + picker.locale.separator + picker.endDate.format(picker.locale.format)
    picker.element.val(value)
}
